import { useReducer} from "react";
import reducer from "./reducer";
import axios from "axios";
import {execute} from "../../utils/helpers/execute";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {IApps} from "../../models/apps/response";
import AppsContext, {internalState} from "./context";
import {IUpdateMessageApp} from "../../models/apps/request";
import {For} from "../../models/commen-question/enum";

export interface IProps {
    children: React.ReactNode;
}

const AppsContextProvider: React.FC<IProps> = (props) => {
    const [state, dispatch] = useReducer(reducer, internalState);
    const location = useLocation();
    const {t} = useTranslation();

    const getData = async () => {
        await execute({
            callback: async () => {
                dispatch({ type: "LOADING", payload: { loading: "list" } });
                const {data} = await axios.get<IApps>(
                    `${process.env.REACT_APP_TEST_BASE_API_URL}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-api-key": "fWlHwX8c.kwgFOYNk4SDlAU8abRDEvLohtyYqXCFR"
                        },
                    }
                );
                await dispatch({
                    type: "SET_LIST",
                    payload: {list: data},
                });
            },
            fallback: (error) => {
            },
            finallyCallback: () => {
                dispatch({ type: "LOADING", payload: { loading: "list" } });
            },
            throwException: false,
        });
    };
    const updateMessageApp = async (id: number, request: FormData) => {
        await execute({
            callback: async () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "update" },
                });

                await axios.patch<IApps>(
                    `${process.env.REACT_APP_TEST_BASE_API_URL}${id}/update/`,
                    request,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            "x-api-key": "fWlHwX8c.kwgFOYNk4SDlAU8abRDEvLohtyYqXCFR",
                        },
                    }
                );

                getData();
            },
            fallback: (error) => {
                console.error("Error updating message app:", error);
            },
            finallyCallback: () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "update" },
                });
            },
            throwException: true,
        });
    };

    return (
        <AppsContext.Provider
            value={{
                ...state,
                actions: {
                    getData,
                    updateMessageApp
                },
            }}
        >
            {props.children}
        </AppsContext.Provider>
    );
};

export default AppsContextProvider;
